import DIApi from './_diApi';

class ContractAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'Contracts';
}

export default new ContractAPI();
